import { render, staticRenderFns } from "./Bec-sucre.vue?vue&type=template&id=1adf4815&scoped=true&"
import script from "./Bec-sucre.vue?vue&type=script&lang=js&"
export * from "./Bec-sucre.vue?vue&type=script&lang=js&"
import style0 from "./Bec-sucre.vue?vue&type=style&index=0&id=1adf4815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf4815",
  null
  
)

export default component.exports